module.exports = __webpack_public_path__ + "static/img/aia-cs-pt.d6008b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/aia-cs-pt.jpg
// module id = rZN0
// module chunks = 0